export const firebaseConfig = {
  apiKey: "AIzaSyBc3BlALbW4yv3RP4KBoQKXJ5kUlrevexM",
  authDomain: "robots-1522b.firebaseapp.com",
  databaseURL: "https://robots-1522b.firebaseio.com",
  projectId: "robots-1522b",
  storageBucket: "robots-1522b.appspot.com",
  messagingSenderId: "173083789125",
  appId: "1:173083789125:web:a5ee62e517ad3886d1202c",
};
